import { ExternalAgreementStatus } from '@/types';

export interface ExternalAgreementFilterValue {
    units: number[];
    groups: number[];
    statuses: ExternalAgreementStatus[];
    searchText: string;
    includeArchived: boolean;
}

export function getInitialExternalAgreementsFilter(): ExternalAgreementFilterValue {
    return {
        units: [],
        groups: [],
        statuses: [],
        searchText: '',
        includeArchived: false,
    };
}

export { default } from './ExternalAgreementFilter';
